import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { th } from './languages/th'
import { en } from './languages/en'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ELanguage, SUPPORTED_LANGUAGES } from './languages/types'
import { getLanguage, setLanguage } from '@/utils/local'

export const i18nResources = {
  [ELanguage.Thai]: {
    translation: th
  },
  [ELanguage.English]: {
    translation: en
  }
}

export const useChangeLanguage = () => {
  const queryClient = useQueryClient()
  return useMutation(async (language: string) => {
    const selectedLanguage = await changeLanguage(language)
    await queryClient.invalidateQueries()
    return selectedLanguage
  })
}

export const defaultNS = 'translation'

export const isSupportedLanguage = (
  value: string | null | undefined
): value is ELanguage =>
  value !== null &&
  value !== undefined &&
  SUPPORTED_LANGUAGES.includes(value as ELanguage)

export const resolveInitialLanguage = (
  storedLanguage: string | null | undefined
): ELanguage =>
  isSupportedLanguage(storedLanguage) ? storedLanguage : ELanguage.English

export const getCurrentLanguage = (): ELanguage =>
  resolveInitialLanguage(i18next.language)

export const changeLanguage = async (str: string) => {
  const language = resolveInitialLanguage(str)
  await i18next.changeLanguage(language)
  setLanguage(language)
  return language
}

const initialLanguage = resolveInitialLanguage(getLanguage())

const configuredI18next = initReactI18next
  ? i18next.use(initReactI18next)
  : i18next

configuredI18next
  .init({
    defaultNS,
    lng: initialLanguage,
    fallbackLng: ELanguage.English,
    resources: i18nResources,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })
  .catch(() => undefined)

export default i18next
